<script>
import Layout from "@/Layouts/PublicLayout.vue";

export default {
    layout: Layout,
};
</script>
<script setup>
import { Head, useForm } from "@inertiajs/vue3";
import { ref, watch } from "vue";

import VDevider from "@/Shared/VDevider.vue";
import VFormOutbound from "./_partials/VFormOutbound.vue";
import VFormDeparting from "./_partials/VFormDeparting.vue";
import VTab from "./_partials/VTab.vue";
import VSwitchLang from "@/Shared/VSwitchLang.vue";
import i18n from "@/Plugins/i18n.js";
import _ from "lodash";
import Swal from "sweetalert2";
import { useTabSurveyStore } from "../../../Store/tabSurvey";
import { useFormDataStore } from "../../../Store/formData";

import { listTabDepartingVisitor, listTabSabahOutbound } from "./tabs.config";

const props = defineProps({
    title: String,
    additional: Object,
});

const { urlStore, survey, surveyFields } = props.additional;

const tabStore = useTabSurveyStore();
const formdataStore = useFormDataStore();

const answers = !_.isEmpty(formdataStore.getForm())
    ? formdataStore.formData
    : props.additional.answers;

const { t } = i18n.global;

const TYPE_SURVEY_DEPARTING = "departing-visitor-survey";
const TYPE_SURVEY_OUTBOUND = "sabah-outbound-survey";

let tabs =
    survey.code == TYPE_SURVEY_DEPARTING
        ? listTabDepartingVisitor
        : listTabSabahOutbound;

if (survey.code == TYPE_SURVEY_OUTBOUND) {
    i18n.global.locale = "en";
}

const currentTab = ref(
    tabStore.current && tabStore.type == survey.code
        ? tabStore.current
        : tabs[0]
);
const currentTabKey = ref(currentTab.value.key);

tabs[0].status = 1;

tabs = tabs.map((item) => {
    const groupCode = survey.code == TYPE_SURVEY_DEPARTING ? "dvs" : "sos";
    item.title = t("public.page.survey.tab_" + groupCode + "." + item.key);
    return item;
});

tabs =
    tabStore.type == survey.code && !_.isEmpty(tabStore.tabs)
        ? tabStore.tabs
        : tabs;

watch(currentTabKey, (newValue) => {
    currentTab.value = tabs.find((item) => item.key == newValue);

    window.scrollTo(0, 100);
});

const handleOnNext = (data) => {
    const currentIndex = tabs.findIndex(
        (item) => item.key == currentTab.value.key
    );
    tabs[currentIndex].status = 2;
    const tab = tabs[currentIndex + 1] ?? tabs[tabs.length - 1];
    tab.status = 1;
    currentTab.value = tab;
    currentTabKey.value = currentTab.value.key;

    tabStore.setCurrent(tab);
    tabStore.setTabs(tabs);
    tabStore.setType(survey.code);

    formdataStore.setForm(data);

    if (currentIndex == tabs.length - 1) {
        submitForm(data);
    }
};

const form = useForm({});

const submitForm = async (data) => {
    const result = await Swal.fire({
        icon: "warning",
        title: i18n.global.t("public.page.survey.swal.title"),
        showCancelButton: true,
        confirmButtonColor: "#28A745",
        cancelButtonColor: "#dfdfdf",
        confirmButtonText: i18n.global.t("public.page.survey.swal.submit"),
        cancelButtonText: i18n.global.t("public.page.survey.swal.cancel"),
    });

    if (!result.isConfirmed) {
        return false;
    }

    form.transform(() => data).post(urlStore, {
        preserveScroll: true,
        onSuccess: () => {
            localStorage.clear();

            tabStore.resetAll();
            formdataStore.reset();
        },
    });
};
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div v-if="survey.code == TYPE_SURVEY_DEPARTING" class="text-end">
        <VSwitchLang />
    </div>
    <div class="mb-4">
        <h3 class="text-center">{{ survey.name }}</h3>
        <VDevider />
    </div>
    <div class="row">
        <div class="col-12 col-md-3">
            <VTab :tabs="tabs" v-model:value="currentTabKey"></VTab>
        </div>
        <div class="col-12 col-md-9">
            <div id="survey-question-container" class="card">
                <div class="card-body">
                    <component
                        :is="
                            survey.code == TYPE_SURVEY_DEPARTING
                                ? VFormDeparting
                                : VFormOutbound
                        "
                        :tab="currentTab"
                        :survey="survey"
                        :answers="answers"
                        :surveyFields="surveyFields"
                        :errors="form.errors"
                        @onNext="handleOnNext"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
